class ShowMore extends HTMLElement {
  constructor() {
    super();

    this.richText = this.querySelector('.js-visible-text');
    this.expandTrigger = this.querySelector('.js-expand-trigger');
    this.fadeGradient = this.querySelector('.js-fade-gradient');

    this.expandTrigger.addEventListener('click', e => {
      if (this.expandTrigger.classList.contains('visible-text-full')) {
        this.expandTrigger.classList.remove('visible-text-full');
      } else {
        this.expandTrigger.classList.add('visible-text-full');
      }

      if (this.expandTrigger.classList.contains('visible-text-full')) {
        this.richText.style.maxHeight = this.richText.scrollHeight + 20 + 'px';
        this.richText.style.paddingBottom = '24px'
      } else {
        this.richText.style.maxHeight = this.dataset.limit + 'px'
        this.richText.style.paddingBottom = 0
      }

      this.expandTrigger.classList.toggle('!tw-rotate-180');
      this.fadeGradient.classList.toggle('tw-hidden');
    });
  }
}

customElements.define('show-more', ShowMore);
